import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import "./navigation.less";

import {
  DemystLogo,
  AdminPanelIcon,
  AnalyticsReportingIcon,
  ApiGatewayIcon,
  BatchWorkspaceIcon,
  DataExchangeIcon,
  FileManagementIcon,
  ExpandMenuIcon,
  LeftArrowIcon
} from "@svgs";

import Item from "./item";

const CustomLogo = ({
  overrideLogo,
  narrow,
  collapsedLogoUrl,
  expandedLogoUrl
}) => {
  // TODO: Refactor styles and find a way to cache image so it doesn't make a request to download the image on every narrow state change
  if (overrideLogo) {
    return (
      <>
        <img
          className={classNames("custom-org-logo", { "d-none": !narrow })}
          src={collapsedLogoUrl}
        />
        <img
          className={classNames("custom-org-logo", { "d-none": narrow })}
          src={expandedLogoUrl}
        />
      </>
    );
  }
  return (
    <div className="demyst-logo-container">
      <DemystLogo narrow={narrow} />
    </div>
  );
};

CustomLogo.propTypes = {
  collapsedLogoUrl: PropTypes.string,
  expandedLogoUrl: PropTypes.string,
  narrow: PropTypes.bool.isRequired,
  overrideLogo: PropTypes.bool.isRequired
};

const Navigation = ({
  currentOrganization,
  currentUser,
  narrow,
  toggleSidebar
}) => {
  const {
    can_show_admin,
    can_show_file_transfers,
    can_show_gateway,
    can_show_reporting
  } = currentUser.permissions;

  const hamburger = (
    <button
      type="button"
      className="Navigation__menuButton"
      onClick={toggleSidebar}
    >
      {narrow ? (
        <ExpandMenuIcon width={20} height={20} />
      ) : (
        <LeftArrowIcon color="white" strokeWidth="8px" width={60} height={60} />
      )}
    </button>
  );

  return (
    <div
      className={classNames("Navigation", {
        "Navigation--collapsed": narrow,
        "Navigation--expanded": !narrow
      })}
    >
      <div className="Navigation__logo">
        <CustomLogo
          narrow={narrow}
          overrideLogo={currentOrganization.override_logo}
          collapsedLogoUrl={currentOrganization.collapsed_logo_url}
          expandedLogoUrl={currentOrganization.expanded_logo_url}
        />
      </div>
      <nav className="Navigation__menu">
        {hamburger}
        <ul>
          <Item
            icon={<BatchWorkspaceIcon />}
            label="Platform"
            to="https://demyst.com/app"
          />
          <Item
            icon={<BatchWorkspaceIcon />}
            label="Workspaces"
            to="/discovery/workspaces"
          />
          {can_show_file_transfers && (
            <Item
              icon={<FileManagementIcon />}
              label="Transfer Files"
              to="/discovery/file_transfers"
            />
          )}
          {can_show_gateway && (
            <Item
              icon={<ApiGatewayIcon />}
              label="Channels"
              to="/discovery/gateway"
            />
          )}
          {can_show_reporting && (
            <Item
              icon={<AnalyticsReportingIcon />}
              label="Analytics"
              to="/discovery/reporting"
            />
          )}
          {can_show_admin && (
            <Item
              className="adminPanel"
              icon={<AdminPanelIcon />}
              label="Settings"
              to="/discovery/admin"
            >
              {/* M2 development
              <Item label="Dashboard" to="/discovery/admin/dashboard" />
              */}
              <Item
                label="Admin Settings"
                to="/discovery/admin/admin_settings"
              />
            </Item>
          )}
        </ul>
      </nav>
      {currentOrganization.override_logo && (
        <div className="Navigation__poweredBy">
          <span>Powered by </span>
          <DemystLogo narrow={narrow} />
        </div>
      )}
    </div>
  );
};

Navigation.propTypes = {
  currentOrganization: PropTypes.shape({
    collapsed_logo_url: PropTypes.string,
    expanded_logo_url: PropTypes.string,
    override_logo: PropTypes.bool.isRequired
  }).isRequired,
  currentUser: PropTypes.shape({
    permissions: PropTypes.shape({
      can_show_admin: PropTypes.bool.isRequired,
      can_show_file_transfers: PropTypes.bool.isRequired,
      can_show_gateway: PropTypes.bool.isRequired,
      can_show_reporting: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  narrow: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired
};

export default withRouter(
  connect(store => ({
    currentOrganization: store.session.data.organization,
    currentUser: store.session.data.user
  }))(Navigation)
);
